<template>
  <!-- Mobile Backdrop Overlay -->
  <div 
    v-if="isOpen" 
    class="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity" 
    @click="$emit('update:isOpen', false)"
  ></div>

  <!-- Sidebar -->
  <aside 
    class="fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transform transition-transform duration-300 ease-in-out md:translate-x-0"
    :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
  >
    <!-- Header -->
    <div class="flex h-16 items-center px-6 border-b border-gray-200 dark:border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-[#035a76] dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
      <span class="ml-3 text-xl font-bold text-[#035a76] dark:text-white">Academics</span>
    </div>

    <!-- Navigation -->
    <nav class="overflow-y-auto h-[calc(100%-4rem)] scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
      <ul class="space-y-1 p-3">
        
        <!-- Dashboard -->
        <li>
          <RouterLink 
            to="/it-dashboard" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li>
                <li>
          <RouterLink 
            to="/employee-accounts" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm-6-4a6 6 0 0112 0v5H3v-5z" />
            </svg>
            Accounts
          </RouterLink>
        </li>
        <!-- Onboarding Form -->
        <li>
          <RouterLink 
            to="/it/onboarding"
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            Onboarding Form
          </RouterLink>
        </li>

        <!-- Information -->
        <li>
          <RouterLink 
            to="/it/personal-info" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Information
          </RouterLink>
        </li>

        <!-- Master Data Section -->
        <li class="pt-4 pb-2">
          <p class="px-3 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Master Data</p>
        </li>

        <li>
          <button
            @click="toggleMasterData"
            :aria-expanded="showMasterData"
            class="flex items-center justify-between w-full px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
          >
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
              </svg>
              Master Data
            </div>
            <svg
              :class="{ 'rotate-180': showMasterData }"
              class="h-4 w-4 transition-transform duration-200"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Master Data Submenu -->
          <!-- <ul v-show="showMasterData" class="mt-1 space-y-1 bg-gray-50 dark:bg-gray-700/40 rounded-lg py-2">
            <li>
              <RouterLink to="/terms" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                Terms
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/academic-years" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                Academic Years
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/holiday-types" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" /></svg>
                Holiday Types
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/sections" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>
                Sections
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/classes" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5" /></svg>
                Classes
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/subjects" class="flex items-center pl-11 pr-3 py-2 text-sm rounded-md text-gray-600 dark:text-gray-300 hover:bg-[#74bd54] hover:text-white transition-colors duration-200" active-class="router-link-active">
                <svg class="h-4 w-4 mr-3 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                Subjects
              </RouterLink>
            </li>
          </ul> -->
        </li>

      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
});

defineEmits(['update:isOpen']);

const showMasterData = ref(false);

const toggleMasterData = () => {
  showMasterData.value = !showMasterData.value;
};
</script>

<style scoped>
.router-link-active {
  background-color: #74bd54;
  color: white !important;
  font-weight: 600;
}

/* Ensure submenu active links also have white icons */
.router-link-active svg {
  color: white !important;
  opacity: 1 !important;
}
</style>